import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import "./global.css";
import store from "./redux/store";
import { Toaster } from 'react-hot-toast'
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Toaster
      position="top-center"
      reverseOrder={false}
    />
    <App />
  </Provider>
);
